import { render, staticRenderFns } from "./ItemExL.vue?vue&type=template&id=00024947"
import script from "./ItemExL.vue?vue&type=script&lang=js"
export * from "./ItemExL.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports